import { useState, useEffect, useRef } from "react";
import HOT from "../data/hotBooks.json";
import LibraryBookList from "./LibraryBookList";
import "./HotBooks.css";

/**
 * 요즘 도서관에서 대출이 오르고 있는 책.
 *
 * 예전에는 이 자리에 '넓어지는 우주'(ExpandingUniverse)가 있었다. 권수만큼
 * 점이 흩어지는 그림인데, 장식이라 눌러도 아무 일이 없었다.
 *
 * 처음에는 책마다 muroo.kr/book/<isbn> 으로 링크를 걸었다. 그런데 15권 중
 * 무루에 책 페이지가 있는 건 3권뿐이라, 나머지 12권은 눌러도 홈으로
 * 떨어졌다 — 누를 수 있는 것처럼 보이는데 아무 일이 없었다.
 *
 * 그래서 그 자리에서 펼친다. 소개글·출판사·연령별 대출은 정보나루가 주고,
 * 새벽에 미리 받아 둔다(scripts/fetch-hot-books.mjs). 누를 때 부르지 않는다.
 * 무루에 페이지가 있는 책에만 '무루에서 보기' 를 단다.
 */


/**
 * @param uid      나. 없으면(게스트) 담기 버튼을 내지 않는다.
 * @param myBooks  내 행성의 책. 이미 있는 책은 '담기' 대신 '내 행성에 있어요'.
 * @param canAdd   게스트·익명이면 false.
 */
export default function HotBooks({ uid = null, myBooks = [], canAdd = false }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  /* 새 소식의 '써보기' 가 이 목록을 열러 온다(HomeScreen 의 goNews). */
  useEffect(() => {
    const onOpen = () => {
      setOpen(true);
      setTimeout(() => rootRef.current?.scrollIntoView({ behavior: "smooth", block: "center" }), 80);
    };
    window.addEventListener("muroo:open-hotbooks", onOpen);
    return () => window.removeEventListener("muroo:open-hotbooks", onOpen);
  }, []);

  const books = HOT?.books ?? [];
  if (!books.length) return null;

  return (
    <div className="hb" ref={rootRef}>
      <button className="hb-btn" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        📈 도서관 대출 급상승 책 <b>{books.length}</b>
        <span className="hb-caret" aria-hidden="true">{open ? "▴" : "▾"}</span>
      </button>

      {open && (
        <div className="hb-panel">
          <div className="hb-head">
            전국 도서관에서 최근 2주간 대출 순위가 오른 책이에요
          </div>

          <LibraryBookList
            books={books} uid={uid} myBooks={myBooks} canAdd={canAdd}
            side={(b) => (
              <span className="hb-rise">
                <b>+{b.diff}</b>
                {/* 며칠 동안 급상승 목록에 들었는지. 하루만 튄 책과 여러 날
                    오른 책을 가르는 값이라 오름폭보다 더 많은 것을 말한다. */}
                <small>{b.days}일</small>
              </span>
            )}
          />

          <div className="hb-foot">
            자료: 도서관 정보나루 · {HOT.from} ~ {HOT.to}
          </div>
        </div>
      )}
    </div>
  );
}
